/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WordPressSignupCreateRequest
 */
export interface WordPressSignupCreateRequest {
    /**
     * The email address of the WordPress site owner
     * @type {string}
     * @memberof WordPressSignupCreateRequest
     */
    email: string;
    /**
     * The domain name of the WordPress site
     * @type {string}
     * @memberof WordPressSignupCreateRequest
     */
    domain: string;
    /**
     * The WordPress admin URL
     * @type {string}
     * @memberof WordPressSignupCreateRequest
     */
    adminUrl: string;
    /**
     * Optional nonce token for secure OTT verification
     * @type {string}
     * @memberof WordPressSignupCreateRequest
     */
    nonceToken?: string;
    /**
     * WordPress integration version. '1' is legacy, '2' uses admin-post.php, '3' uses nonce key verification
     * @type {string}
     * @memberof WordPressSignupCreateRequest
     */
    version: WordPressSignupCreateRequestVersionEnum;
}


/**
 * @export
 */
export const WordPressSignupCreateRequestVersionEnum = {
    _1: '1',
    _2: '2',
    _3: '3'
} as const;
export type WordPressSignupCreateRequestVersionEnum = typeof WordPressSignupCreateRequestVersionEnum[keyof typeof WordPressSignupCreateRequestVersionEnum];


/**
 * Check if a given object implements the WordPressSignupCreateRequest interface.
 */
export function instanceOfWordPressSignupCreateRequest(value: object): value is WordPressSignupCreateRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('domain' in value) || value['domain'] === undefined) return false;
    if (!('adminUrl' in value) || value['adminUrl'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    return true;
}

export function WordPressSignupCreateRequestFromJSON(json: any): WordPressSignupCreateRequest {
    return WordPressSignupCreateRequestFromJSONTyped(json, false);
}

export function WordPressSignupCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WordPressSignupCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'domain': json['domain'],
        'adminUrl': json['adminUrl'],
        'nonceToken': json['nonceToken'] == null ? undefined : json['nonceToken'],
        'version': json['version'],
    };
}

export function WordPressSignupCreateRequestToJSON(json: any): WordPressSignupCreateRequest {
    return WordPressSignupCreateRequestToJSONTyped(json, false);
}

export function WordPressSignupCreateRequestToJSONTyped(value?: WordPressSignupCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'domain': value['domain'],
        'adminUrl': value['adminUrl'],
        'nonceToken': value['nonceToken'],
        'version': value['version'],
    };
}

